import { render, staticRenderFns } from "./DetailTitle.vue?vue&type=template&id=ed8ba656&scoped=true&"
import script from "./DetailTitle.vue?vue&type=script&lang=js&"
export * from "./DetailTitle.vue?vue&type=script&lang=js&"
import style0 from "./DetailTitle.vue?vue&type=style&index=0&id=ed8ba656&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8ba656",
  null
  
)

export default component.exports